import React, { useState, useEffect } from "react";
import Table from "../../../../components/ACS-Dashboard/ACS-Blocks/Table";
import axios from "axios";

const CustomerMessages = () => {
  const headers = [
    "Order ID", "Item Name", "Quantity", "Buyer", "Carrier", "Location", "Delivery Date", "Status"
  ];

  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage, setOrdersPerPage] = useState(10);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_BASE_URL+"/api/order-details");
        setOrders(response.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, []);

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(orders.length / ordersPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const formattedOrders = currentOrders.map((order) => ({
   'Order ID': order.orderNumber,
    'Item Name': order.itemName,
    'Quantity': order.quantity,
    'Buyer': order.buyer,
    'Carrier': order.carrier,
    'Location': order.location,
    'Delivery Date': order.deliveryDate,
    'Status': (
      <span className={`py-1 px-3 rounded-full text-xs font-medium ${
        order.status === 'Acknowledged' ? 'bg-blue-200 text-blue-800' :
        order.status === 'Partially Shipped' ? 'bg-yellow-200 text-yellow-800' :
        order.status === 'Backordered' ? 'bg-red-200 text-red-800' :
        order.status === 'Delivered' ? 'bg-teal-200 text-teal-800' :
        'bg-gray-200 text-gray-800'
      }`}>
        {order.status}
      </span>
    ),
  }));

  return (
    <div>
      {/* 🔹 Table Section */}
      <div className="overflow-y-auto max-h-96">
        <Table headers={headers} data={formattedOrders} />
      </div>
    </div>
  );
};

export default CustomerMessages;
